import { RFValue } from "react-native-responsive-fontsize";

export default {
  COLORS: {
    ALERT: "#ec1414",
    ICON: '#00517B', //COR DOS CADEADOS E DAS SETAS PARA O LADO
    ICON_HEADER_PURCHASE: "#466779", //COR DAS SETINHAS 
    BACKGROUND_HEADER: "none", //COR DE TODOS OS CABEÇALHOS

    //TELA CLICKCOURSE, PLANS e SIGNUP
    ICON_HEADER: "#466779",  //COR DA PALAVRA ESCOLHER COMPRA, CADASTRAR-SE E COMPLETAR PAGAMENTO

    //CORES GERAIS
    PRIMARY_900: "#00517B", //COR PRINCIPAL DOS DETALHES DO APP - CHECKBOX, FECHAR TERMOS DE USO, ETC
    PRIMARY_800: "#466779", //COR PRINCIPAL MAIS CLARA PARA INPUT LOGIN E ACTIVITY INDICATOR
    PRIMARY_700: "#EF9181", //COR MAIS CLARA DO CLIENTE = COR PRINCIPAL MAIS CLARA PARA INPUT LOGIN E ACTIVITY INDICATOR
    TEXT_BUTTON: "#FFFFFF", //USADA PARA O TEXTO DOS BOTÕES LOGIN, CLICKCOURSE, SIGNUP - COR DE FUNDO É A PRIMARY_900

    //CORES DO DRAWER
    DRAWER_SELECTED: "#466779", //COR DRAWER CLICADO E DO TEXTO DO DRAWER

    //TELAS: LOGIN, CLICKCOURSE, SIGNUP E PLANS
    BACKGROUND_ABOUT: "#FFFFFF", //COR PARA A ABOUT, DRAWER, CLICK COURSE, PLANS, EDITPROFILE, LOGIN E CADASTRO
    TITLE_ABOUT: '#272727', //TAMANHOS EXTRABIG, BIG E STANDARD
    TEXT_ABOUT: '#272727', //TAMANHOS MEDIUM, SMALL E EXTRASMALL

    //TELA TERMOS DE USO
    BACKGROUND_TERMS: "#FFFFFF", //COR PARA O FUNDO DOS TERMOS
    
    //TELA MAIN
    ICON_HEADER_CLICKCLASS: "#FFFFFF", //COR DO ÍCONE VOLTAR DA CLICKCLASS
    ICON_HEADER_MAIN: "#FFFFFF", //COR DO ICONE DRAWER
    BACKGROUND_MAIN: "#272727", //COR PARA A MAIN E CLICKCLASS
    TITLE_OVERPHOTO_MAIN: "black", //USADA PARA O TÍTULO E SUBTÍTULO DA MAIN
    TITLE_MAIN: 'white', //USADA PARA PARA OS TAMANHOS EXTRABIG, BIG E STANDARD
    TEXT_MAIN: 'white', //USADA PARA PARA OS TAMANHOS MEDIUM, SMALL E EXTRASMALL

    //FOOTER TELA ABOUT E DRAWER
    BACKGROUND_FOOTER: "#272727", //COR DO RODAPÉ
    TEXT_FOOTER: '#FFEFF8', //USADA PARA O TEXTO DO RODAPÉ

    GRADIENT_MAIN:[
      'rgba(0,0,0,0.1)',
      'rgba(0,0,0,0)',
      'rgba(250,250,250,0.2)',
      '#272727'
    ],

    //BOTÕES ARQUIVAR E PUBLICAR
    BACKGROUND_PUBLISH: "#466779", //COR DO RODAPÉ
    BACKGROUND_ARCHIVE: "#FFFFFF", //COR DO RODA
    TEXT_PUBLISH: "#272727", //USADA PARA O TEXTO DO RODAPÉ
    TEXT_ARCHIVE: "#272727", //USADA PARA O TEXTO DO RODAPÉ
  },

  FONTFAMILY: {
    BOLD: "text_Bold",
    MEDIUM: "text_Medium",
    REGULAR: "text_Regular",
    LIGHT: "text_Light",
    TITLE: "text_Title",
    SUBTITLE: "text_Subtitle",
    TEXTS: "text_Texts"
  },
  FONTSIZE: {
    EXTRABIG: RFValue(30, 980), //USADA 1X NA COURSES
    BIG: 26,
    STANDARD: 20,
    MEDIUM: 18,
    SMALL: 16,
    EXTRASMALL: 13,
  },
};
